import { CLOSE_ICON } from '../../../../assets/icons';
import { Portal } from '../../../../components/Modal';
import { useState } from 'react';
import tutorRequestsApi from '../../../../api/tutor-requests';
import { Button } from '@wot/components';

export function AddVideoLink({ setAddVideoLink, tutor, setTutor }: any) {
  const [videoLink, setVideoLink] = useState<string>('');
  const [embedLink, setEmbedLink] = useState<string>('');
  const [isValid, setIsValid] = useState<boolean>(false);

  const onSubmit = async () => {
    validateYouTubeUrl();
    if (isValid) {
      //TODO: set tutor's video link as embed link
      tutorRequestsApi.addIntroVideo({
        ytLink: embedLink,
        email: tutor.personal.data.email
      }).then(() => {
        setTutor({
          ...tutor,
          video: {
            status: "complete",
            link: embedLink
          }
        })
      });
    }
    setAddVideoLink(false);
  };

  function validateYouTubeUrl() {
    var url = videoLink;
    if (url != undefined || url != '') {
      // eslint-disable-next-line
      var regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=|\?v=)([^#\&\?]*).*/;
      var match = url.match(regExp);
      if (match && match[2].length == 11) {
        setIsValid(true);
        setEmbedLink('https://www.youtube.com/embed/' + match[2] + '?autoplay=0');
      } else {
        setIsValid(false);
        setEmbedLink('');
      }
    }
  }

  return (
    <Portal>
      <div className="fixed bottom-0 left-0 w-screen h-[500px] z-40 bg-white rounded-t-xl border">
        <div className="w-full flex justify-end pt-10 px-10">
          <img src={CLOSE_ICON} alt="close" className="h-4 cursor-pointer" onClick={() => setAddVideoLink(false)} />
        </div>
        <div className="flex flex-col items-center px-20 overflow-y-scroll">
          <h3 className="text-xl font-medium text-center pb-10">Add Introduction Video Link</h3>
          <div className="w-sm w-max-[900px] flex flex-col gap-4 justify-center leading-8">
            <p className="text-md">Upload link to the Introduction Video</p>
            <input
              value={videoLink}
              onChange={(e) => {
                setIsValid(false);
                setVideoLink(e.target.value);
              }}
              placeholder="Paste the link here"
              className={`w-full text-sm px-3 py-3 placeholder:text-black/40 placeholder:font-light 
         border outline-none focus:outline-none rounded-md`}
            />
          </div>
        </div>
        <div className="flex py-5 items-center justify-center">
          {isValid && embedLink ? (
            <iframe width="250" height="150" src={embedLink}></iframe>
          ) : (
            <p className="w-[250px] h-[150px] flex justify-center text-red-600 font-bold">Video Link is not Valid!</p>
          )}
        </div>
        <hr />
        <div className="w-full bottom-0 flex gap-2 justify-center">
          {videoLink && !isValid && (
            <div className="w-32 py-3">
              <Button text="Get Preview" onClick={() => validateYouTubeUrl()} type="s-outlined" role="submit" />
            </div>
          )}
          {videoLink && embedLink && isValid && (
            <div className="w-32 py-3">
              <Button text="Submit" onClick={() => onSubmit()} role="submit" />
            </div>
          )}
        </div>
      </div>
    </Portal>
  );
}
